import React from "react";
import styles from './hamburger-layout.module.scss';

const HamburgerLayout = (props) => {
    return (
      <div className={styles.container}>
        <div className={styles.row}>
          {props.children}
        </div>
      </div>
    );
};

export default HamburgerLayout;